<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="col-sm-12">
      <div class="card card-body mb-0">

        <div class="row mb-2" v-if="role === UserRole.ADMIN">
          <div class="form-group col-sm-12">
            <ul class="navbar-nav overflow-auto flex-row gap-4">
              <li v-for="(value, tab) in StatusTabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                <a href="#" @click.prevent="selectStatusTab(tab)" class="nav-link tab" :class="{'active': activeStatusTab === tab}">{{ helper.trans(`users.status.${tab}`) }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.name')" v-model="requestDTO.query">
              </div>
            </div>
          </div>

          <div v-if="role === UserRole.TRADER_TEAM_LEAD" class="form-group col-md-3 col-lg-3 col-xl-2 me-2 d-flex">
            <div class="col p-0 d-flex align-items-center">
              <div class="form-check small mb-0">
                <input class="form-check-input" v-model="requestDTO.isMainTeamLead" true-value="y"  type="checkbox" value="" id="isMainTeamLead">
                <label class="form-check-label" for="isMainTeamLead">
                  {{ helper.trans('labels.is_main_teamLead')}}
                </label>
              </div>
            </div>
          </div>

          <div class="form-group col">
            <div class="col-auto p-0 text-end ">
              <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
              <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="card card-body">
        <div class="overflow-auto">
          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <td></td>
              <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
              <th>2FA</th>
              <th v-if="role === UserRole.TRADER_TEAM_LEAD || role === UserRole.REFERRAL || role === UserRole.ADMIN" class="text-capitalize-first">{{ helper.trans('labels.balances') }}</th>
              <th class="text-end">
                <button type="button" v-if="role !== UserRole.ADMIN || (store.getters.hasPermission(UserPermission.CREATE_ADMINS))" v-on:click="showEditModal({})" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                <b-modal dialog-class="modal-lg"
                         :title="createModalTitle"
                         :modelValue="createModal"
                         body-class="pt-0"
                         @update:modelValue="createModal = $event"
                >
                  <template #default>
                    <UserForm ref="createForm" :role="role"></UserForm>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                    <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                      <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                    </LoaderWrapper>
                  </template>
                </b-modal>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in response.items" :key="user.id" class="">
              <td>
                <i v-b-tooltip.hover :title="helper.trans('labels.user_blocked')" v-if="user.isBlocked" class="fa fa-ban text-danger"></i>
              </td>
              <td>{{ user.id }}</td>
              <td>
                <UserNameLabel :user="user"></UserNameLabel>
              </td>
              <td>
                <i v-b-tooltip.hover :title="helper.trans('labels.enabled')" v-if="user.is2faEnabled" class="fa fa-check text-success"></i>
                <i v-b-tooltip.hover :title="helper.trans('labels.disabled')" v-else class="fa fa-ban text-danger"></i>
              </td>
              <td v-if="role === UserRole.TRADER_TEAM_LEAD || role === UserRole.REFERRAL || role === UserRole.ADMIN">
                <div v-for="userAccount in user._accounts">

                  <div class="row">
                    <div class="col-sm-12 d-flex align-items-center justify-content-between">
                      <AccountWidget hide-insurance :account="userAccount"></AccountWidget>
                      <div class="d-flex align-items-center flex-column">
                        <div class="d-flex align-items-center">
                        <div v-if="isAdmin || isOperator" class="me-2 text-secondary">
                          <small v-b-tooltip.hover :title="userAccount.id">{{ userAccount.id.substring(0, 8) }}</small> <copy-button :value="userAccount.id"></copy-button>
                        </div>
                        <div class="btn-group me-2" v-if="user.id === store.getters.getUser.id">
                          <button type="button" @click.prevent="withdrawAccount = userAccount" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa-solid fa-upload"></i> {{ helper.trans("button.withdraw") }}</button>
                          <button type="button" class="btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="visually-hidden"></span>
                          </button>
                          <ul class="dropdown-menu">
                            <li>
                              <a class="dropdown-item text-capitalize-first" href="#" @click.prevent="withdrawalWhitelistModal?.show(userAccount);">{{helper.trans('labels.edit_whitelist')}}</a>
                            </li>
                            <li>
                              <a class="dropdown-item text-capitalize-first" href="#" @click.prevent="autoWithdrawalSettingsModal?.show(userAccount)">{{helper.trans('labels.edit_auto_withdrawal')}}</a>
                            </li>
                          </ul>
                        </div>

                        <button v-if="isAdmin || isOperator" @click="$refs.accountOperationsModal.showModal(userAccount)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first">
                          {{ helper.trans("menu.items.accountOperations") }}
                        </button>
                        </div>
                        <div class="text-end">
                          <small class="text-danger" style="font-size: 70%;" v-if="userAccount.isAutoWithdrawalEnabled &&  userAccount.withdrawalWhitelistsEnabled">
                            {{ helper.trans('labels.auto_withdrawal_enabled', {
                            address: userAccount.autoWithdrawalAddress,
                            sum: userAccount.autoWithdrawalMinSum
                              ? numberFormatter.formatMoney(userAccount.autoWithdrawalMinSum, 0)
                              : ''
                          }) }}
                          </small>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </td>
              <td class="text-end">
                <button v-if="isAdmin && store.getters.hasPermission(UserPermission.VIEW_USER_SESSION_HISTORY)" type="button" @click.prevent="downloadSessionHistory(user.id)" class="btn btn-sm btn-outline-secondary text-nowrap text-capitalize me-2">
                  <i class="fa fa-file-download"></i> {{ helper.trans('button.download_session_history') }}
                </button>
                <button v-if="isAdmin" type="button" @click="showEditModal(user)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                <button v-if="isOperator && store.getters.hasPermission(passwordPermission)" type="button" @click.prevent="showChangePasswordModal(user)" class="btn btn-sm btn-outline-secondary text-nowrap text-capitalize">
                  <i class="fa fa-key"></i> {{helper.trans('button.change_password')}}
                </button>

                <div v-if="user.role === UserRole.TRADER_TEAM_LEAD" class="btn-group">
                  <button  type="button" @click="routingTeamLead = user" class="ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-percent"></i> {{helper.trans('labels.percent_rates')}}</button>
                  <button type="button" class="btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false" data-bs-reference="parent">
                    <span class="visually-hidden"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="downloadTradersRate(user.id)"><i class="fa fa-file-export"></i> {{ helper.trans('labels.download_traders_percent_rates')}}</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="ratesImportModal = user"><i class="fa fa-file-import"></i> {{ helper.trans('labels.import_traders_percent_rates')}}</a>
                    </li>
                  </ul>
                </div>

                <button v-if="role === UserRole.REFERRAL && store.getters.getAppData?.REFERRAL_MERCHANT_FEES_ENABLED" type="button" @click="referralFeesUser = user" class="ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"><i class="fa fa-percent"></i> {{helper.trans('labels.referral_fees')}}</button>
              </td>
            </tr>
            </tbody>
          </table>

          <b-pagination
            v-if="response.totalCount > response.items.length"
            v-model="page"
            :total-rows="response.totalCount"
            :per-page="response.limit"
            :limit="20"
            @update:modelValue="loadList()"
            prev-text="Back"
            next-text="Next"
            align="start"
            first-number
            hide-goto-end-buttons
            hide-ellipsis
          ></b-pagination>

        </div>
      </div>
    </div>

    <InviteLinkConfirmModal ref="inviteLinkConfirmModal"></InviteLinkConfirmModal>
    <AccountOperationsModal ref="accountOperationsModal"></AccountOperationsModal>

    <b-modal dialog-class="modal-lg"
             :title="`${routingTeamLead?.name}`"
             :modelValue="routingTeamLead !== null"
             body-class="pt-0"
             @update:modelValue="$event === false && (routingTeamLead = null)"
    >
      <template #default>
        <TeamLeadRewardSettingsForm ref="routingRuleForm" :team-lead="routingTeamLead"></TeamLeadRewardSettingsForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="routingTeamLead = null" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
        <LoaderWrapper ref="loaderRoutingRule" :zoom="0.5">
          <button type="button" @click="saveRouting()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <b-modal dialog-class="modal-lg"
             :title="`${referralFeesUser?.name}`"
             :modelValue="referralFeesUser !== null"
             body-class="pt-0"
             @update:modelValue="$event === false && (referralFeesUser = null)"
    >
      <template #default>
        <ReferralMerchantFeesTable v-if="referralFeesUser" :referral-id="referralFeesUser.id"></ReferralMerchantFeesTable>
      </template>
      <template #footer>
        <button type="button" v-on:click="referralFeesUser = null" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
      </template>
    </b-modal>

    <b-modal :title="helper.trans('labels.import_traders_percent_rates')" :modelValue="ratesImportModal !== null" header-class="text-capitalize" body-class="pt-0" footer-class="d-flex justify-content-between" @update:modelValue="$event === false && (ratesImportModal = null)">
      <template #default>

        <div class="row mb-3 mt-3">
          <div class="col-sm-12">
            <div style="cursor: pointer; border:1px dashed" v-bind="dropzone.getRootProps()" class="payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center">
              <input v-bind="dropzone.getInputProps()" />
              <p class="p-0 m-0">{{ helper.trans('labels.payout_upload_files')}}</p>
            </div>
          </div>
        </div>

        <div v-if="importFile">
          <div class="col-sm-12">
            <i class="fa fa-paperclip"></i> <span class="me-2">{{ importFile.name}}</span>
            <a href="#" @click.prevent="importFile = null">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>

      </template>
      <template #footer>
        <button type="button" v-on:click="ratesImportModal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ helper.trans("button.cancel") }}</button>

        <LoaderWrapper ref="loaderRatesImportModal" :zoom="0.5">
          <button type="button" v-on:click="importTraderRates(ratesImportModal?.id)" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans("labels.import") }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>
    <b-modal :title="helper.trans('labels.withdrawal')" :modelValue="withdrawAccount !== null" header-class="text-capitalize" body-class="pt-0" footer-class="d-flex justify-content-between" @update:modelValue="$event === false && (withdrawAccount = null)">
      <template #default>
        <WithdrawalForm ref="withdrawalForm" :account="withdrawAccount"></WithdrawalForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="withdrawAccount = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ helper.trans("button.cancel") }}</button>
        <LoaderWrapper ref="loaderWithdrawalForm" :zoom="0.5">
          <button type="button" v-on:click="createWithdraw()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans("button.withdraw") }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <AutoWithdrawalSettingsModal @account:updated="update()" ref="autoWithdrawalSettingsModal"></AutoWithdrawalSettingsModal>
    <WithdrawalWhitelistModal ref="withdrawalWhitelistModal" @updated="loadList()"></WithdrawalWhitelistModal>
    <ChangePasswordModal ref="changePasswordModal"></ChangePasswordModal>
  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {useSessionHistoryDownload} from "@/service/useSessionHistoryDownload";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import UserDTO from "@/models/UserDTO";
import UserForm from "@/components/Form/UserForm.vue";
import UserFormDTO from "@/models/form/UserFormDTO";
import InviteLinkConfirmModal from "@/components/InviteLinkConfirmModal.vue";
import {UserRole} from "@/models/enum/UserRole";
import AccountWidget from "@/components/AccountWidget.vue";
import AccountDTO from "@/models/AccountDTO";
import PaginationDTO from "@/models/PaginationDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import {useStore} from "vuex";
import AccountOperationsModal from "@/components/AccountOperationsModal.vue";
import TeamLeadRewardSettingsForm from "@/components/Form/TeamLeadRewardSettingsForm.vue";
import {useDropzone} from "vue3-dropzone";
import {useNotification} from "@kyvg/vue3-notification";
import {UserPermission} from "@/models/enum/UserPermission";
import WithdrawalForm from "@/components/Form/WithdrawalForm.vue";
import AutoWithdrawalSettingsModal from "@/components/AutoWithdrawalSettingsModal.vue";
import WithdrawalWhitelistModal from "@/components/WithdrawalWhitelistModal.vue";
import ReferralMerchantFeesTable from "@/components/ReferralMerchantFeesTable.vue";
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";

enum StatusTabs {
  active = 'active', blocked = 'blocked', all = 'all'
}

const statusTabBlockedFilter = {
  [StatusTabs.all]: null,
  [StatusTabs.active]: false,
  [StatusTabs.blocked]: true,
}

const notification = useNotification()
export default defineComponent({
  components: {
    WithdrawalWhitelistModal,
    AutoWithdrawalSettingsModal,
    WithdrawalForm,
    TeamLeadRewardSettingsForm,
    ReferralMerchantFeesTable,
    UserNameLabel,
    AccountWidget,
    LoaderWrapper,
    CopyButton,
    UserForm,
    InviteLinkConfirmModal,
    AccountOperationsModal,
    ChangePasswordModal
  },
  props: {
    role: String
  },
  setup(props, { emit }) {
    const store = useStore()
    const defaultCreateForm = {
      id: null,
      name: null,
      email: null,
      password: '',
      isBlocked: false,
      role: props.role,
      createInvite: true,
      appId: null,
      isManualWithdrawals: false,
      permissions: [],
      is2faEnabled: false,
    } as UserFormDTO

    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof UserForm> | null>(null)
    const inviteLinkConfirmModal = ref<InstanceType<typeof InviteLinkConfirmModal> | null>(null)
    const loaderRoutingRule = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const routingRuleForm = ref<InstanceType<typeof TeamLeadRewardSettingsForm> | null>(null)
    const loaderRatesImportModal = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderWithdrawalForm = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const withdrawalForm = ref<InstanceType<typeof WithdrawalForm> | null>(null)
    const autoWithdrawalSettingsModal = ref<InstanceType<typeof AutoWithdrawalSettingsModal> | null>(null)
    const withdrawalWhitelistModal = ref<InstanceType<typeof WithdrawalWhitelistModal> | null>(null)
    const changePasswordModal = ref<InstanceType<typeof ChangePasswordModal> | null>(null)

    const passwordPermission = computed(() => {
      switch (props.role) {
        case UserRole.ADMIN: return UserPermission.RESET_ADMIN_PASSWORD;
        case UserRole.OPERATOR: return UserPermission.RESET_OPERATOR_PASSWORD;
        default: return UserPermission.RESET_TRADER_PASSWORD; // REFERRAL, TRADER_TEAM_LEAD
      }
    })

    const defaultStatusTab = props.role === UserRole.ADMIN ? StatusTabs.active : StatusTabs.all

    const state = reactive({
      withdrawAccount: null as AccountDTO|null,
      ratesImportModal: null as UserDTO|null,
      importFile: null as any,
      routingTeamLead: null as UserDTO|null,
      referralFeesUser: null as UserDTO|null,
      createModalTitle: null,
      createModal: false,
      page: 1,
      activeStatusTab: defaultStatusTab as StatusTabs,
      requestDTO: {
        isMainTeamLead: null,
        isBlocked: statusTabBlockedFilter[defaultStatusTab],
        query: '',
        roles: [props.role]
      } as any,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<UserDTO>
    });

    const loadList = async () => {
      loader.value?.show()
      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.users(state.response, state.requestDTO);

      let accountIds = state.response.items.map(trader => trader.id)

      let userAccounts = {} as AccountDTO[]|any;
      for (const account of (await api.userAccounts({offset:0, limit: accountIds.length} as PaginationDTO, {userIds: accountIds})).items) {
        if (!userAccounts[account.userId]) {
          userAccounts[account.userId] = [];
        }
        userAccounts[account.userId].push(account.account)
      }

      for (const item of state.response.items) {
        item._accounts = userAccounts[item.id] ?? []
      }

      loader.value?.hide()
    }

    const showEditModal = async (dto: UserDTO) => {
      if (dto.id) {
        state.createModalTitle = helper.trans("labels.edit_user", {name: dto.name})
        createForm.value?.setForm({
          ...defaultCreateForm,
          ...dto
        } as UserFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_user")
        createForm.value?.setForm({...defaultCreateForm, password: helper.generatePassword()} as UserFormDTO)
      }

      state.createModal = true;
    }

    const showChangePasswordModal = (user: UserDTO) => {
      changePasswordModal.value?.show(user.id, api.usersChangePassword)
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then((user: UserDTO) => {
          state.createModal = false;
          if (user?.inviteToken) {
            const url = store.getters['getInviteLink'](user);
            inviteLinkConfirmModal.value?.show(url);
          }
          loadList();
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })

    }

    const applyFilters = async () => {
      state.page = 1;
      loadList()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.activeStatusTab = defaultStatusTab
      state.requestDTO = {
        isMainTeamLead: null,
        isBlocked: statusTabBlockedFilter[defaultStatusTab],
        query: '',
        roles: [props.role]
      }
      loadList()
    }

    const selectStatusTab = (tab: StatusTabs) => {
      state.activeStatusTab = tab
      state.requestDTO.isBlocked = statusTabBlockedFilter[tab]
      state.page = 1;
      loadList()
    }

    const saveRouting = async () => {
      loaderRoutingRule.value?.show()

      try {
        await routingRuleForm.value?.save();
        state.routingTeamLead = null;
      } finally {
        loaderRoutingRule.value?.hide()
      }
    }

    const downloadTradersRate = async (teamleadId: number) => {
      loader.value?.show()

      try {
        const data = await api.call.traderRewardSettings.exportByTeamLead(teamleadId);
        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url
        link.setAttribute('download', 'percent_rates.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } finally {
        loader.value?.hide()
      }
    }

    onMounted(() => {
      loadList()
    });


    const importTraderRates = async (teamleadId: number) => {
      loaderRatesImportModal.value?.show()
      try {
        await api.call.traderRewardSettings.importByTeamLead(teamleadId, state.importFile)
        notification.notify({title: helper.trans('labels.traders_percent_rates_updated')});
        state.ratesImportModal = null;
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans(`server_errors.INTERNAL_ERROR`)});
      } finally {
        loaderRatesImportModal.value?.hide()
      }
    }

    const createWithdraw = async () => {
      loaderWithdrawalForm.value?.show()
      withdrawalForm.value?.save().then(() => {
        state.withdrawAccount = null;
        loaderWithdrawalForm.value?.hide()
        loadList()
      }).catch(() => {
        loaderWithdrawalForm.value?.hide()
      })
    }

    const onDrop = async (acceptFiles: any, rejectReasons: any) => {
      for (const file of acceptFiles) {
        state.importFile = file
      }
    }

    const dropzone = useDropzone({ onDrop, accept:['.xlsx'], maxFiles: 1 });

    const update = () =>  {
      emit('updated')
    }

    const {downloadSessionHistory} = useSessionHistoryDownload(loader)

    return {
      downloadSessionHistory,
      ...toRefs(state),
      downloadTradersRate,
      loader,
      createForm,
      loaderCreateFrom,
      dateHelper,
      numberFormatter,
      helper,
      showEditModal,
      save,
      loadList,
      inviteLinkConfirmModal,
      UserRole,
      store,
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      clearFilters,
      applyFilters,
      selectStatusTab,
      StatusTabs,
      saveRouting,
      loaderRoutingRule,
      routingRuleForm,
      loaderRatesImportModal,
      dropzone,
      importTraderRates,
      UserPermission,
      createWithdraw,
      withdrawalForm,
      loaderWithdrawalForm,
      autoWithdrawalSettingsModal,
      withdrawalWhitelistModal,
      update,
      changePasswordModal,
      showChangePasswordModal,
      passwordPermission,
    }
  }
})
</script>
